<template>
  <new-modal-wrapper
    :modal-classes="`transfer-design-modal transfer-design-modal--step-${step}`"
    :widthModal="'100%'"
    :maxWidthModal="500"
    :heightModal="isMobile ? '100%' : 'auto'"
    :fullHeight="true"
    ref="transferDesignModal"
    modal-name="transferDesignComponent"
    :headerTitle="translations.transferDesignModalTitle"
    ctaPrimaryButton="transferDesignModalCta"
    @before-open="initModal"
    @closed="onClose"
    @cta-action="$refs.transferDesignContent.onContinue()"
    :showCloseIcon="showCloseIcon"
  >
    <transfer-design-content
      ref="transferDesignContent"
      v-if="step === 'choose-style' && (!isLoadingData || loadExternal3dViewer)"
      @showIconButton="showIconButton"
      @blockCtaPrimaryButton="blockCtaPrimaryButton"
      @showCtaPrimaryButton="showCtaPrimaryButton"
      @continue="goToTransferStyleStep"
      @showCloseIcon="onShowCloseIcon"
      @updateLoadingData="updateLoadingData"
    ></transfer-design-content>
    <section
      v-else-if="step === 'transfer-style'"
      class="transfer-design--wrapper content modal-scroll-area"
    >
      <p class="transfer-design--description">
        {{ translations.transferDesignLoadingText }}
      </p>
    </section>
    <div
      class="loader__wrapper transfer-design-modal__spinner-wrapper"
    >
      <loading-spinner
        ref="spinner"
        :show-spinner-default="showSpinner"
        displayText="translations.transferDesignLoadingText"
      ></loading-spinner>
    </div>
  </new-modal-wrapper>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner'
import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';
import transferDesignContent from '@/components/Customizer/TransferDesignModal/components/TransferDesignContent';
import transferDesign from '@/mixins/TransferDesign';

export default {
  name: "transferDesignModal",
   data() {
    return {
      step: "choose-style", // the second step is "transfer-style"
      showCloseIcon: true,
      imageUrls: {},
      prices: {},
      loadExternal3dViewer: false,
      isLoadingData: true
    };
  },
  components: {
    LoadingSpinner,
    newModalWrapper,
    transferDesignContent,
  },
  mixins: [transferDesign],
  methods: {
    blockCtaPrimaryButton(block) {
      const tooltip = block ?
        {
          placement: 'top-center',
          trigger: 'click',
          classes: 'transfer-design__tooltip spaced',
          container: false,
          content: `<div>
            <div class="transfer-design__tooltip-error-icon">!</div>
            <p>${ this.translations["transferDesignErrorTooltip"] }</p>
          </div>`,
        } : null;
        this.$refs.transferDesignModal.blockCtaPrimaryButton(block);
        this.$refs.transferDesignModal.tooltipCtaPrimaryButton(tooltip);
    },
    showCtaPrimaryButton(show) {
      this.$refs.transferDesignModal.showCtaPrimaryButton(show);
    },
    onShowCloseIcon(show) {
      this.showCloseIcon = show;
    },
    showIconButton(value) {
      this.$refs.transferDesignModal.showIconButton(value);
    },
    updateLoadingData(value) {
      this.isLoadingData = value;
    }
  }
}
</script>
